import CompanyProductsPage from './company-products-page';
export default CompanyProductsPage;